import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrLoadingCarousel from "UI/FnrLoadingCarousel";

import NoteCard from "../NoteCard";

import EmptyState from "./EmptyState";

const NotesList = ({
  notes,
  isMobile,
  currentFontFamily,
  handleNoteClick,
  hasInitiallyLoaded,
  isSubsequentLoad,
  searchTerm,
  triggerLogin,
  NotloggedInAndClosedNetwork,
  NotloggedInAndNoNotes,
}) => {
  // Show login prompt for closed networks if not logged in
  if (NotloggedInAndClosedNetwork || NotloggedInAndNoNotes) {
    return <EmptyState type="login" triggerLogin={triggerLogin} />;
  }

  if (notes.length > 0) {
    return (
      <FramerMotionList initial="hidden" animate="visible">
        {notes.map((note, index) => {
          return (
            <motion.article
              key={note.ID}
              initial={
                hasInitiallyLoaded ? false : { opacity: 0, y: 40, scale: 0.9 }
              }
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{
                duration: 0.5,
                ease: "easeInOut",
                delay: index * 0.1, // Stagger each item by 0.1 seconds
              }}
            >
              <NoteCard
                note={note}
                isMobile={isMobile}
                currentFontFamily={currentFontFamily}
                onNoteClick={handleNoteClick}
              />
            </motion.article>
          );
        })}
      </FramerMotionList>
    );
  }

  // Show loading state during subsequent loads (like search)
  if (isSubsequentLoad) {
    return (
      <InlineLoadingContainer>
        <FnrLoadingCarousel
          show={true}
          whiteBackground={false}
          color="#ffffff"
        />
      </InlineLoadingContainer>
    );
  }

  // Show empty state if no notes
  return <EmptyState type="no-notes" searchTerm={searchTerm} />;
};

const FramerMotionList = styled(motion.main)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const InlineLoadingContainer = styled.div`
  position: relative;
  display: flex;
  margin-top: 130px;
  justify-content: center;
  align-items: center;
`;

NotesList.propTypes = {
  notes: PropTypes.array.isRequired,
  isMobile: PropTypes.bool,
  currentFontFamily: PropTypes.string,
  handleNoteClick: PropTypes.func.isRequired,
  hasInitiallyLoaded: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubsequentLoad: PropTypes.bool,
  searchTerm: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  triggerLogin: PropTypes.func,
  NotloggedInAndClosedNetwork: PropTypes.bool,
  NotloggedInAndNoNotes: PropTypes.bool,
};

export default NotesList;
